const restaurant = {
  restaurant: "Restoran", // translated 
  restaurants: "Restoran", // translated 
  category: "Kategori", // translated 
  score: "Skor", // translated 
  priceQuartile: "Kuartil harga", // translated 
  scoreLowestFirst: "Skor (terendah dahulu)", // translated 
  scoreHighestFirst: "Skor (tertinggi dahulu)", // translated 
  priceLowestFirst: "Harga (terendah dahulu)", // translated 
  priceHighestFirst: "Harga (tertinggi dahulu)", // translated 
  allPrices: "Semua harga", // translated 
  reserve: "Rizab", // translated 
  dining: "Makan", // translated 
};







export default restaurant;
